<template>
    <div>
        <b-modal
            :id="'modal-edit-module-' + module.id"
            title="Editar Módulo"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit.stop.prevent="submit">

                    <!-- Field -->
                    <b-form-group
                        label="Nome do Módulo">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                        ></b-form-input>
                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Editar Módulo
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['module'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                name: null,
            }
        }
    },
    created() {
        this.form.name = this.module.name;

        this.$root.$on('open-modal-edit-module-' + this.module.id, () => {
            this.$bvModal.show('modal-edit-module-' + this.module.id);
        })
    },
    methods: {
        submit() {
            this.loading = true;

            axios.put('/teacher/courses/' + this.module.course_id + '/modules/' + this.module.id, this.form)
                .then(response => {

                    // Callback
                    this.$emit('updated')

                    // Close Modal
                    this.$bvModal.hide('modal-edit-module-' + this.module.id);

                    // Message
                    this.$toast.success('Módulo atualizado com sucesso!')

                    // Clear Errors
                    this.errors = {}
                })
                .catch(errors => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
}
</script>

<style scoped>

</style>
